import { NumberFormat } from "src/model/shop.model";
import {
  getCurrencyCode,
  getCurrencyDecimals,
  getCurrencyFormat,
  getCurrencySeparators,
  getCurrencySymbol,
} from "../../../utils/Prices";
import appState from "src/model/state";

export interface CurrencyLocale {
  currencyFormat: string;
  currencySymbol: string;
  currencySeparators: NumberFormat;
  currencyDecimals: number;
  currencyCode: string;
}
export const useCurrencyLocale = (): CurrencyLocale => {
  const { market } = appState.get();
  const currencyLocale = {
    currencyFormat: getCurrencyFormat(market),
    currencySymbol: getCurrencySymbol(market),
    currencySeparators: getCurrencySeparators(market),
    currencyDecimals: getCurrencyDecimals(market),
    currencyCode: getCurrencyCode(market),
  };
 
  return currencyLocale;
};
